// @flow
import { deleteEvent, selectEvent, showPopup, updateEventValue } from '~/core/state/ui/schedule/actions';
import {
    getDataId,
    getScheduleMode,
    getScheduleType,
    getSelectedEvent,
    getEventTypeFromEvent
} from '~/core/state/ui/schedule/selectors';
import { getDualColors, getValueColor, getValueLabel, hasPicker, updateValue } from '../schedule-type';

import { connect } from 'react-redux';
import Event from './component';
import { getAppSetting } from '~/core/state/app-settings/selectors';
import { getConfig } from '~/core/state/config/selectors';
import { getStateForProduct } from '~/core/state/products/selectors';
import { SCHEDULE_STOP_TOOLTIP } from '~/core/constants/app-settings';
import { scheduleModesEnum } from '~/core/constants/schedule';
import { setAppSettings } from '~/core/state/app-settings/actions';

const mapStateToProps = (state, ownProps) => {
    const config = getConfig(state);

    const { event } = ownProps;
    const selectedEvent = getSelectedEvent(state, ownProps);
    const isSelected =
        !!selectedEvent &&
        event.get('dayIndex') === selectedEvent.get('dayIndex') &&
        event.get('eventIndex') === selectedEvent.get('eventIndex');
    const scheduleType = getScheduleType(state, ownProps);
    const scheduleMode = getScheduleMode(state, ownProps);
    const slotType = getEventTypeFromEvent(state, { ...ownProps, event });

    const eventColor = getValueColor({
        config,
        type: scheduleType,
        slotType,
        value: event.get('value')
    });
    const productId = getDataId(state, ownProps);
    const productState = getStateForProduct(state, { id: productId });
    const getLabel = formatMessage =>
        getValueLabel({
            config,
            productState,
            formatMessage,
            type: scheduleType,
            slotType,
            value: event.get('value')
        });
    const dualColors = getDualColors({ type: scheduleType });
    const scheduleStopTooltip = getAppSetting(state, SCHEDULE_STOP_TOOLTIP);

    return {
        dualColors,
        eventColor,
        getLabel,
        isSelected,
        scheduleMode,
        scheduleStopTooltip,
        scheduleType,
        selectedEvent
    };
};

const mapDispatchToProps = {
    deleteEvent,
    selectEvent,
    setAppSettings,
    showPopup,
    updateEventValue
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { isSelected, scheduleMode, scheduleStopTooltip, scheduleType } = stateProps;
    const { deleteEvent, selectEvent, setAppSettings, showPopup, updateEventValue } = dispatchProps;
    const { canBeDeleted, componentId, event, isSelectedDay } = ownProps;

    return {
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
        selectEvent: e => {
            if (isSelectedDay) {
                e.stopPropagation();
                if (isSelected) {
                    if (!scheduleStopTooltip) {
                        setAppSettings({ [SCHEDULE_STOP_TOOLTIP]: true });
                    }
                    if (hasPicker({ type: scheduleType })) {
                        showPopup({ componentId });
                    } else {
                        const updatedEvent = updateValue(scheduleType, event);
                        updateEventValue({ componentId, updatedEvent });
                    }
                } else if (scheduleMode === scheduleModesEnum.DEFAULT) {
                    selectEvent(ownProps);
                } else if (scheduleMode === scheduleModesEnum.DELETE_EVENT) {
                    canBeDeleted && deleteEvent({ componentId, eventToDelete: event });
                }
            } else if (scheduleMode === scheduleModesEnum.DEFAULT) {
                selectEvent(ownProps);
            }
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Event);



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/event/index.js